import { Auth0ContextInterface } from "@auth0/auth0-react";
import {
  CreateCalendarEventPayload,
  DeleteCalendarEventPayload,
  GetCalendarEventsPayload,
  UpdateCalendarEventPayload,
} from "redux/actions/calendar";
import CalendarBookingDomain from "entities/domain/calendar/calendar-domain";
import { RequestType } from "services/request-type";
import calendarTransformFromDtoToDomain from "entities/transformers/calendar-transformer";
import { CalendarBookingDTO } from "entities/dto/CalendarDTO";
import {
  deleteRequest,
  mutationRequest,
  putRequest,
  request,
} from "util/methods";

export default class CalendarsService {
  public static async getCalendarEvents(
    { getAccessTokenSilently }: Auth0ContextInterface,
    payload: GetCalendarEventsPayload
  ): Promise<CalendarBookingDomain[]> {
    const accessToken = await getAccessTokenSilently();

    const calendarResponse = await request(
      RequestType.GET,
      accessToken,
      `/bookings?start_at=${payload.startAt}&end_at=${payload.endAt}&tz=${payload.timezone}`
    );

    const bookings: CalendarBookingDTO[] = calendarResponse.data;

    return bookings.map(calendarTransformFromDtoToDomain);
  }

  public static async createCalendarEvent(
    { getAccessTokenSilently }: Auth0ContextInterface,
    payload: CreateCalendarEventPayload
  ): Promise<CalendarBookingDomain> {
    const accessToken = await getAccessTokenSilently();

    const calendarResponse = await mutationRequest(
      RequestType.POST,
      accessToken,
      `/bookings`,
      {
        start_at: payload.startAt,
        end_at: payload.endAt,
        tz: payload.tz,
        title: payload.title,
        description: payload.description,
        agent_ids: payload.agentIds,
        customer_id: payload.customerId,
        notification_customer_channel_id: payload.notificationCustomerChannelId,
      }
    );

    const booking: CalendarBookingDTO = calendarResponse.data;

    return calendarTransformFromDtoToDomain(booking);
  }

  public static async updateCalendarEvent(
    { getAccessTokenSilently }: Auth0ContextInterface,
    payload: UpdateCalendarEventPayload
  ): Promise<CalendarBookingDomain> {
    const accessToken = await getAccessTokenSilently();

    const calendarResponse = await putRequest(
      RequestType.PUT,
      accessToken,
      `/bookings/${payload.bookingId}`,
      {
        start_at: payload.startAt,
        end_at: payload.endAt,
        tz: payload.tz,
        title: payload.title,
        description: payload.description,
        agent_ids: payload.agentIds,
        customer_id: payload.customerId,
        notify_customer: payload.notifyCustomer,
        notification_customer_channel_id: payload.notificationCustomerChannelId,
      }
    );

    const booking: CalendarBookingDTO = calendarResponse.data;

    return calendarTransformFromDtoToDomain(booking);
  }

  public static async deleteCalendarEvent(
    { getAccessTokenSilently }: Auth0ContextInterface,
    payload: DeleteCalendarEventPayload
  ): Promise<CalendarBookingDomain> {
    const accessToken = await getAccessTokenSilently();

    const calendarResponse = await deleteRequest(
      RequestType.DELETE,
      accessToken,
      `/bookings/${payload.bookingId}`
    );

    const booking: CalendarBookingDTO = calendarResponse.data;

    return calendarTransformFromDtoToDomain(booking);
  }
}
